import React from 'react';

const FrontPageRunToGoal = () => {
    return (
        <>
            <div className='goal-intro__background'></div>

            <div className="goal-intro--V2">
                {/* Nubes de fondo más rápidas */}
                <div className="clouds-container">
                    <div className="cloud cloud-1"></div>
                    <div className="cloud cloud-2"></div>
                    <div className="cloud cloud-3"></div>
                </div>

                {/* CONTENIDO PRINCIPAL */}
                <div className="goal-intro--V2__logo-container">
                    <div className='d-flex align-items-center justify-content-center'>
                        <img src='/img/favicon/Big.png' style={{ width: '100%', maxWidth: '100px', marginRight: '30px' }} alt="Logo ADSL" />
                        <img src="/img/games/runtogoal/daikin/daikin-logotipo-five-digital-minds.png" className="goal-intro--V2__logo" alt="Daikin" />
                        <img src='/img/favicon/Big.png' style={{ width: '100%', maxWidth: '100px', marginLeft: '30px' }} alt="Logo ADSL" />
                    </div>
                    
                    <p className="goal-intro--V2__text text-uppercase fw-bold mt-4">Presentan</p>
                    <p className="goal-intro--V2__title text-uppercase fw-bold">Tiro a gol</p>
                </div>

                {/* BALÓN CON GIRO */}
                <img src="/img/games/runtogoal/balon-grande.png" className="goal-intro--V2__ball" alt="Balón" />
            </div>

            <div className='FooterCredits' style={{ position: 'fixed', bottom: '0', left: '50%', transform: 'translateX(-50%)', color: '#000', fontSize: '30px', zIndex: 100 }}>
                Hecho con ♥ por Interaktia | 2026
            </div>
        </>
    );
};

export { FrontPageRunToGoal };









// import React, { useState } from 'react';

// const FrontPageRunToGoal = () => {
//     // ESTADO TEMPORAL PARA PROBAR LAS 3 OPCIONES
//     const [opcion, setOpcion] = useState(1);

//     return (
//         <div className={`goal-intro goal-intro--opt${opcion}`}>
            
//             {/* BOTONERA TEMPORAL DE PRUEBAS (Bórrala cuando decidas cuál usar) */}
//             <div style={{ position: 'absolute', top: '20px', left: '20px', zIndex: 999, display: 'flex', gap: '10px' }}>
//                 <button className={`btn btn-sm ${opcion === 1 ? 'btn-primary' : 'btn-light'}`} onClick={() => setOpcion(1)}>1. Nubes ☁️</button>
//                 <button className={`btn btn-sm ${opcion === 2 ? 'btn-info' : 'btn-light'}`} onClick={() => setOpcion(2)}>2. Enfriamiento ❄️</button>
//                 <button className={`btn btn-sm ${opcion === 3 ? 'btn-dark' : 'btn-light'}`} onClick={() => setOpcion(3)}>3. Túnel Viento 🌪️</button>
//             </div>

//             {/* ELEMENTOS VISUALES DE FONDO SEGÚN LA OPCIÓN */}
//             {opcion === 1 && (
//                 <div className="clouds-container">
//                     <div className="cloud cloud-1"></div>
//                     <div className="cloud cloud-2"></div>
//                     <div className="cloud cloud-3"></div>
//                 </div>
//             )}

//             {opcion === 2 && (
//                 <div className="freeze-overlay"></div>
//             )}

//             {opcion === 3 && (
//                 <div className="wind-tunnel">
//                     <div className="wind-line line-1"></div>
//                     <div className="wind-line line-2"></div>
//                     <div className="wind-line line-3"></div>
//                     <div className="wind-line line-4"></div>
//                 </div>
//             )}

//             {/* CONTENIDO PRINCIPAL */}
//             <div className="goal-intro__logo-container">
//                 <div className='d-flex align-items-center justify-content-center'>
//                     <img src='/img/favicon/Big.png' style={{ width: '100%', maxWidth: '100px', marginRight: '30px' }} alt="Logo ADSL" />
                    
//                     {/* Filtro blanco/brillante para que Daikin resalte en fondos oscuros si es la opción 3 */}
//                     <div className="daikin-logo-wrapper">
//                         <img src="/img/games/runtogoal/daikin/daikin-logotipo-five-digital-minds.png" className="goal-intro__logo" alt="Daikin" />
//                     </div>
                    
//                     <img src='/img/favicon/Big.png' style={{ width: '100%', maxWidth: '100px', marginLeft: '30px' }} alt="Logo ADSL" />
//                 </div>
                
//                 <p className="goal-intro__text text-uppercase fw-bold mt-4">Presentan</p>
//                 <p className="goal-intro__title text-uppercase fw-bold">Tiro a gol</p>
//             </div>

//             {/* BALÓN (Con clase dinámica para que su animación cambie según el tema) */}
//             <img src="/img/games/runtogoal/balon-grande.png" className={`goal-intro__ball goal-intro__ball--opt${opcion}`} alt="Balón" />

//             <p className='FooterCredits' style={{ position: 'fixed', bottom: '0', left: '50%', transform: 'translateX(-50%)', color: opcion === 3 ? '#fff' : '#000', fontSize: '30px', zIndex: 100 }}>
//                 Hecho con ♥ por Interaktia | 2026
//             </p>
//         </div>
//     );
// };

// export { FrontPageRunToGoal };









// import React from 'react';

// const FrontPageRunToGoal = () => {
//     return (
//         <div className="goal-intro">
//             {/* Ocultamos la cancha y ponemos un fondo oscuro para resaltar el logo */}
//             <div className="goal-intro__logo-container">
//                 <div className='d-flex'>
//                     <img src='/img/favicon/Big.png' style={{ width: '100%', maxWidth: '120px', marginRight: '40px' }} />
//                     <img src="/img/games/runtogoal/daikin/daikin-logotipo-five-digital-minds.png" className="goal-intro__logo" alt="Daikin" />
//                     <img src='/img/favicon/Big.png' style={{ width: '100%', maxWidth: '120px', marginLeft: '30px' }} />
//                 </div>
//                 <p className="goal-intro__text text-uppercase fw-bold">Presentan</p>
//                 <p className="goal-intro__title text-uppercase fw-bold">Tiro a gol</p>
//             </div>

//             {/* El balón que cae del cielo y rebota */}
//             <img src="/img/games/runtogoal/balon-grande.png" className="goal-intro__ball" alt="Balón" />

//             <p className='FooterCredits' style={{ position: 'fixed', bottom: '0', left: '50%', transform: 'translateX(-50%)', color: '#000', fontSize: '30px' }}>Hecho con ♥ por Interaktia | 2026</p>
//         </div>
//     );
// };

// export { FrontPageRunToGoal };